import { Text } from '@medly-components/core';
import { HeaderText, RegionVersionField, UnAssignMapText, ZoneTilesHeaderWrapper } from './ZoneTileHeader.styled';
import { Region } from '../../types';
import { format } from 'date-fns';
import Styled from '../../../../components/common/Styled';
import { getRegionDisplayName } from 'pages/Map/regionHelper';
import { useUserContext } from 'context/UserContext';

type ZoneTileHeader = {
    region: Region;
    onMapUnAssign?: () => void;
};
export const ZoneTileHeader = ({ region, onMapUnAssign }: ZoneTileHeader) => {
    const { user } = useUserContext();

    return (
        <ZoneTilesHeaderWrapper>
            <Styled.FlexBox alignItems="center" colGap="1rem">
                <HeaderText textVariant="h3" data-testid="region-name">{`${getRegionDisplayName(region)} Map Zones`}</HeaderText>
                {user?.isAdmin && onMapUnAssign ? (
                    <UnAssignMapText data-testid="unassign-map" onClick={onMapUnAssign}>
                        Unassign
                    </UnAssignMapText>
                ) : null}
            </Styled.FlexBox>
            {user?.isAdmin ? (
                <RegionVersionField>
                    {region.updatedAt ? (
                        <>
                            <Text data-testid={'last-updatedAt'} textVariant="body2">
                                Last updated on {format(new Date(region.updatedAt), 'do MMM yyyy')}
                            </Text>
                            <Styled.Bullet />
                        </>
                    ) : (
                        <></>
                    )}
                    <Text data-testid={'version'} textVariant="body2">
                        Version {region.version}
                    </Text>
                </RegionVersionField>
            ) : null}
        </ZoneTilesHeaderWrapper>
    );
};
